import "./DashboardPage.scss";
import MainLayout from "../../layouts/main-layout/MainLayout";
import PlayerTable from "./components/player-table/PlayerTable";
import TitleBox from "../../ui/title-box/TitleBox";

const DashboardPage = () => {
  return (
    <MainLayout>
      <div className="dashboard-page">
        <TitleBox title={"Live player list"} />
        <PlayerTable />
      </div>
    </MainLayout>
  );
};

export default DashboardPage;
